import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import Box from '../../../../components/Box';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import CustomTextInput from '../../../../components/CustomTextInput';
import { Helpers } from '../../../../helpers/Helpers';
import { GetAntrepoInByIdResponseAntrepoInVehicle, GetAntrepoInByIdResponseAntrepoInVehicleProduct } from '../../../../models/response/antrepoIn/GetAntrepoInByIdResponse';
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { ConstantService } from '../../../../services/ConstantService';
import { GTipService } from '../../../../services/GTipService';
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import { AntrepoOutService } from '../../../../services/AntrepoOutService';
import { GetAntrepoOutListByAntrepoInIdResponse } from '../../../../models/response/antrepoOut/GetAntrepoOutListByAntrepoInIdResponse';
import { GetAntrepoByIdResponse } from '../../../../models/response/antrepo/GetAntrepoByIdResponse';
import { AntrepoService } from '../../../../services/AntrepoService';
import { AntrepoAreaTypeEnum } from '../../../../models/common/Enums';
import CustomNumberInput from '../../../../components/CustomNumberInput';
import { GetGTipByIdResponse } from '../../../../models/response/gTip/GetGTipByIdResponse';

interface Props {
    productInformationRef: any
    antrepoInVehicleProducts: GetAntrepoInByIdResponseAntrepoInVehicleProduct[]
    setSelectedProductType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setAntrepoInVehicleProducts: React.Dispatch<React.SetStateAction<GetAntrepoInByIdResponseAntrepoInVehicleProduct[]>>
    defaultProductType: CustomSingleSelectModel | undefined
    antrepoInVehicles: GetAntrepoInByIdResponseAntrepoInVehicle[]
    selectedProductType: CustomSingleSelectModel | undefined
    antrepoInId: string | undefined
    ledgerNo: string | undefined
    selectedAntrepo: CustomSingleSelectModel | undefined
    isDisabledFromLock: boolean
}

const ProductInformation = ({
    productInformationRef,
    antrepoInVehicleProducts,
    setSelectedProductType,
    setAntrepoInVehicleProducts,
    defaultProductType,
    antrepoInVehicles,
    selectedProductType,
    antrepoInId,
    ledgerNo,
    selectedAntrepo,
    isDisabledFromLock
}: Props) => {
    const dispatch = useDispatch();
    const [potQuantity, setPotQuantity] = useState<string | undefined>('0');
    const [grossWeight, setGrossWeight] = useState<string | undefined>('0');
    const [netWeight, setNetWeight] = useState<string | undefined>('0');
    const [volume, setVolume] = useState<string | undefined>('0');
    const [area, setArea] = useState<string | undefined>('0');
    const [palletCount, setPalletCount] = useState<string | undefined>('0');
    const [antrepoInVehicleProductId, setAntrepoInVehicleProductId] = useState<string | undefined>(undefined);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedGTip, setSelectedGTip] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedProductLocation, setSelectedProductLocation] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedGroup, setSelectedGroup] = useState<CustomSingleSelectModel | undefined>(antrepoInVehicles.length == 1 ? { label: antrepoInVehicles[0].groupNo + '', value: antrepoInVehicles[0].groupNo + '' } : undefined);
    const [selectedProductKind, setSelectedProductKind] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedPotType, setSelectedPotType] = useState<CustomSingleSelectModel | undefined>(undefined);

    const setUpdateItem = () => {
        var o = antrepoInVehicleProducts.filter(x => x.isSelected)[0];

        setAntrepoInVehicleProductId(o.antrepoInVehicleProductId);
        setSelectedGTip(o.gTipId && o.gTipName ? { label: o.gTipName, value: o.gTipId } : undefined);
        setSelectedGroup(o.groupNo ? { label: o.groupNo, value: o.groupNo, additionalValue1: o.antrepoInVehicleProductId } : undefined)
        setSelectedProductType(o.productTypeId && o.productTypeName ? { label: o.productTypeName, value: o.productTypeId } : undefined);
        setSelectedProductLocation(o.productLocationId && o.productLocationName ? { label: o.productLocationName, value: o.productLocationId } : undefined);
        setSelectedProductKind(o.productKindId && o.productKindName ? { label: o.productKindName, value: o.productKindId } : undefined);
        setSelectedPotType(o.potTypeId && o.potTypeName ? { label: o.potTypeName, value: o.potTypeId } : undefined);
        setPotQuantity(o.potQuantity);
        setGrossWeight(o.grossWeight);
        setNetWeight(o.netWeight);
        setPalletCount(o.palletCount);
        setVolume(o.volume);
        setArea(o.area);
        setIsOpen(true);
        scrollTo();
    }

    const deleteItems = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            for (var i = 0; i < antrepoInVehicleProducts.filter(x => x.isSelected).length; i++) {
                if (antrepoInId) {
                    var response2: GetAntrepoOutListByAntrepoInIdResponse = await AntrepoOutService.getAntrepoOutListByAntrepoInId(antrepoInId);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }

                    if (response2.data.length > 0) {
                        toast.error(ledgerNo + ' defter numaralı giriş kayıdına ait çıkış kayıdı olduğu için silme yapılamaz!')
                        return;
                    }
                }
            }

            setAntrepoInVehicleProducts(antrepoInVehicleProducts.filter(x => !x.isSelected));
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setAntrepoInVehicleProducts(antrepoInVehicleProducts.map(function (x) {
            if (x.antrepoInVehicleProductId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const selectAll = () => {
        var isAllSelected = antrepoInVehicleProducts.length == antrepoInVehicleProducts.filter(x => x.isSelected).length;

        setAntrepoInVehicleProducts(antrepoInVehicleProducts.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            setSelectedGroup(antrepoInVehicles.length == 1
                ? { label: antrepoInVehicles[0].groupNo + '', value: antrepoInVehicles[0].groupNo + '', additionalValue1: antrepoInVehicles[0].antrepoInVehicleId }
                : { label: antrepoInVehicles.filter(x => x.isSelected)[0].groupNo + '', value: antrepoInVehicles.filter(x => x.isSelected)[0].groupNo + '', additionalValue1: antrepoInVehicles.filter(x => x.isSelected)[0].antrepoInVehicleId });
            scrollTo();
            return;
        }

        setAntrepoInVehicleProductId('');
        setSelectedGTip(undefined);
        setSelectedGroup(antrepoInVehicles.length == 1 ? { label: antrepoInVehicles[0].groupNo + '', value: antrepoInVehicles[0].groupNo + '', additionalValue1: antrepoInVehicles[0].antrepoInVehicleId } : undefined);
        setSelectedProductType(defaultProductType);
        setSelectedProductLocation(undefined);
        setSelectedPotType(undefined);
        setSelectedProductKind(undefined);
        setPotQuantity('0');
        setGrossWeight('0');
        setNetWeight('0');
        setPalletCount('0');
        setVolume('0');
        setArea('0');
        setIsOpen(false);
        scrollTo();
    }

    const saveItem = () => {
        if (!selectedGroup) {
            toast.error('Grup Sıra No alanını doldurunuz!');
        }
        else if (!selectedProductKind) {
            toast.error('Ürün Cinsi alanını doldurunuz!');
        }
        else if (!selectedPotType) {
            toast.error('Kap Cinsi alanını doldurunuz!');
        }
        else if (Helpers.isEmpty(potQuantity)) {
            toast.error('Kap Adet alanını doldurunuz!');
        }
        else if (Helpers.isEmpty(grossWeight)) {
            toast.error('Brüt Ağırlık (Kg) alanını doldurunuz!');
        }
        else if (Helpers.isEmpty(netWeight)) {
            toast.error('Net Ağırlık (Kg) alanını doldurunuz!');
        }
        else if (Helpers.isEmpty(volume)) {
            toast.error('Hacim (M3) alanını doldurunuz!');
        }
        else if (Helpers.isEmpty(area)) {
            toast.error('Alan (M2) alanını doldurunuz!');
        }
        else if (Helpers.toNumber(potQuantity) < 0) {
            toast.error('Kap Adet alanı negatif olamaz!');
        }
        else if (Helpers.toNumber(grossWeight) < 0) {
            toast.error('Brüt Ağırlık (Kg) alanı negatif olamaz!');
        }
        else if (Helpers.toNumber(netWeight) < 0) {
            toast.error('Net Ağırlık (Kg) alanı negatif olamaz!');
        }
        else if (Helpers.toNumber(volume) < 0) {
            toast.error('Hacim (M3) alanı negatif olamaz!');
        }
        else if (Helpers.toNumber(area) < 0) {
            toast.error('Alan (M2) alanı negatif olamaz!');
        }
        else if (netWeight && grossWeight && Helpers.toNumber(netWeight) > Helpers.toNumber(grossWeight)) {
            toast.error('Net Ağırlık (Kg) alanı Brüt Ağırlık (Kg) alanından büyük olamaz!');
        }
        // else if ((Helpers.toNumber(potQuantity) + Helpers.toNumber(grossWeight) + Helpers.toNumber(netWeight) + Helpers.toNumber(volume) + Helpers.toNumber(area)) > 0 && (Helpers.toNumber(potQuantity) == 0 || Helpers.toNumber(grossWeight) == 0 || Helpers.toNumber(netWeight) == 0 || Helpers.toNumber(volume) == 0 || Helpers.toNumber(area) == 0)) {
        //     toast.error('Girilen sayıların hepsi sıfırlanmadan herhangi bir tanesi sıfırlanamaz!');
        // }
        else {
            if (Helpers.isEmpty(antrepoInVehicleProductId)) {
                var o: GetAntrepoInByIdResponseAntrepoInVehicleProduct = {
                    antrepoInVehicleProductId: Helpers.generateUUID(true),
                    isSelected: false,
                    antrepoInVehicleId: selectedGroup.additionalValue1 + '',
                    area: area,
                    grossWeight: grossWeight,
                    groupNo: selectedGroup.value,
                    gTipId: selectedGTip?.value,
                    gTipName: selectedGTip?.label,
                    netWeight: netWeight,
                    palletCount: palletCount,
                    potQuantity: potQuantity,
                    productTypeId: selectedProductType?.value,
                    productTypeName: selectedProductType?.label,
                    volume: volume,
                    productLocationId: selectedProductLocation?.value,
                    productLocationName: selectedProductLocation?.label,
                    productKindId: selectedProductKind?.value,
                    productKindName: selectedProductKind?.label,
                    potTypeId: selectedPotType?.value,
                    potTypeName: selectedPotType?.label,
                }

                setAntrepoInVehicleProducts([...antrepoInVehicleProducts, o])
            }
            else {
                setAntrepoInVehicleProducts(antrepoInVehicleProducts.map(function (x) {
                    if (x.antrepoInVehicleProductId == antrepoInVehicleProductId) {
                        x.isSelected = false;
                        x.antrepoInVehicleId = selectedGroup.additionalValue1 + '';
                        x.groupNo = selectedGroup.value;
                        x.area = area;
                        x.grossWeight = grossWeight;
                        x.gTipId = selectedGTip?.value;
                        x.gTipName = selectedGTip?.label;
                        x.netWeight = netWeight;
                        x.palletCount = palletCount;
                        x.potQuantity = potQuantity;
                        x.productTypeId = selectedProductType?.value;
                        x.productTypeName = selectedProductType?.label;
                        x.volume = volume;
                        x.productLocationId = selectedProductLocation?.value;
                        x.productLocationName = selectedProductLocation?.label;
                        x.productKindId = selectedProductKind?.value;
                        x.productKindName = selectedProductKind?.label;
                        x.potTypeId = selectedPotType?.value;
                        x.potTypeName = selectedPotType?.label;
                    }

                    return x;
                }))
            }

            setAntrepoInVehicleProductId('');
            setSelectedGTip(undefined);
            setSelectedGroup(antrepoInVehicles.length == 1 ? { label: antrepoInVehicles[0].groupNo + '', value: antrepoInVehicles[0].groupNo + '', additionalValue1: antrepoInVehicles[0].antrepoInVehicleId } : undefined);
            setSelectedProductType(defaultProductType);
            setSelectedProductLocation(undefined);
            setSelectedPotType(undefined);
            setSelectedProductKind(undefined);
            setPotQuantity('0');
            setGrossWeight('0');
            setNetWeight('0');
            setPalletCount('0');
            setVolume('0');
            setArea('0');
            setIsOpen(false);
            scrollTo();
        }
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = productInformationRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const getStockGroupedList = () => {
        var noRefList: GetAntrepoInByIdResponseAntrepoInVehicleProduct[] = JSON.parse(JSON.stringify(antrepoInVehicleProducts));

        noRefList = noRefList.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0
            || Helpers.toNumber(x.stockGrossWeight) > 0
            || Helpers.toNumber(x.stockNetWeight) > 0
            || Helpers.toNumber(x.stockVolume) > 0
            || Helpers.toNumber(x.stockArea) > 0);

        if (noRefList.length == 0)
            return [];

        var newList: GetAntrepoInByIdResponseAntrepoInVehicleProduct[] = [];

        for (var i = 0; i < noRefList.length; i++) {
            var findObj = newList.find(x => x.gTipId == noRefList[i].gTipId && Helpers.toNumber(x.daysInStorage) == Helpers.toNumber(noRefList[i].daysInStorage) && x.productTypeId == noRefList[i].productTypeId);

            if (findObj) {
                findObj.stockPotQuantity = (Helpers.toNumber(findObj.stockPotQuantity) + Helpers.toNumber(noRefList[i].stockPotQuantity)).toString();
                findObj.stockGrossWeight = (Helpers.toNumber(findObj.stockGrossWeight) + Helpers.toNumber(noRefList[i].stockGrossWeight)).toString();
                findObj.stockNetWeight = (Helpers.toNumber(findObj.stockNetWeight) + Helpers.toNumber(noRefList[i].stockNetWeight)).toString();
                findObj.stockVolume = (Helpers.toNumber(findObj.stockVolume) + Helpers.toNumber(noRefList[i].stockVolume)).toString();
                findObj.stockArea = (Helpers.toNumber(findObj.stockArea) + Helpers.toNumber(noRefList[i].stockArea)).toString();
            }
            else {
                newList.push({
                    ...noRefList[i],
                    daysInStorage: noRefList[i].daysInStorage,
                    gTipName: noRefList[i].gTipName,
                    productTypeName: noRefList[i].productTypeName,
                    stockPotQuantity: noRefList[i].stockPotQuantity,
                    stockGrossWeight: noRefList[i].stockGrossWeight,
                    stockNetWeight: noRefList[i].stockNetWeight,
                    stockVolume: noRefList[i].stockVolume,
                    stockArea: noRefList[i].stockArea,
                })
            }
        }

        return newList;
    }

    const getProductLocationList = async () => {
        try {
            if (selectedAntrepo) {
                var response: GetAntrepoByIdResponse = await AntrepoService.getAntrepoById(selectedAntrepo.value)
                if (!response.isSuccess) {
                    toast.error(response.message)

                    return {
                        isSuccess: true,
                        data: []
                    };
                }

                return {
                    isSuccess: true,
                    data: response.data.antrepoAreas.filter(x => x.antrepoAreaTypeKey == AntrepoAreaTypeEnum.STOKLAMA)
                };
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }

        return {
            isSuccess: true,
            data: []
        };
    }

    return (
        <div className='containerPart' ref={productInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Ürün Bilgileri</h4>
                    <h4 className="mb-10 text-black">Giriş</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Grup Sıra No</label>

                                        <CustomSingleSelect
                                            onChange={setSelectedGroup}
                                            selectedValue={selectedGroup}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: antrepoInVehicles.map(function (x) {
                                                        var obj: CustomSingleSelectModel | undefined = {
                                                            label: x.groupNo + '',
                                                            value: x.groupNo + '',
                                                            additionalValue1: x.antrepoInVehicleId
                                                        }

                                                        return obj;
                                                    })
                                                }
                                            }}
                                            labelName='label'
                                            valueName='value'
                                            additionalValue1Name="additionalValue1"
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">GTip No</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedGTip}
                                            onChange={(selectedValue) => {
                                                if (selectedValue) {
                                                    while (selectedValue.label.startsWith('-'))
                                                        selectedValue.label = selectedValue.label.slice(1);
                                                }

                                                setSelectedGTip(selectedValue);
                                            }}
                                            onMenuOpen={(searchTerm) => GTipService.getGTipList(0, 100, searchTerm)}
                                            labelName='gTip1'
                                            label2Name='gTipDesc'
                                            valueName='gTipId'
                                            additionalValue1Name='gTipDesc'
                                            isPaging
                                            isOrdering={false}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Ürün Cinsi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedProductKind}
                                            onChange={setSelectedProductKind}
                                            onMenuOpen={() => ConstantService.getConstantList('PRODUCT_KIND', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ürün Özelliği</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedProductType}
                                            onChange={setSelectedProductType}
                                            onMenuOpen={() => ConstantService.getConstantList('PRODUCT_TYPE', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kap Cinsi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedPotType}
                                            onChange={setSelectedPotType}
                                            insertable={{
                                                onSubmit: { code: 'POT_TYPE' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('POT_TYPE', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kap Adet</label>
                                        <CustomNumberInput value={potQuantity} setValue={setPotQuantity} />
                                    </div>


                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Brüt Ağırlık (Kg)</label>
                                        <CustomNumberInput value={grossWeight} setValue={setGrossWeight} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Net Ağırlık (Kg)</label>
                                        <CustomNumberInput value={netWeight} setValue={setNetWeight} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hacim (M3)</label>
                                        <CustomNumberInput value={volume} setValue={setVolume} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Alan (M2)</label>
                                        <CustomNumberInput value={area} setValue={setArea} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Palet Adet</label>

                                        <CustomNumberInput value={palletCount} setValue={setPalletCount} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ürün Lokasyonu</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedProductLocation}
                                            onChange={setSelectedProductLocation}
                                            onMenuOpen={async () => await getProductLocationList()}
                                            labelName='name'
                                            valueName='antrepoAreaId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    {
                        !isDisabledFromLock && (
                            <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                                <Box onClick={antrepoInVehicles.filter(a => a.isSelected).length == 1 ? cancelAdding : undefined} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={antrepoInVehicles.filter(a => a.isSelected).length == 1 ? "1" : "0.5"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                                    </Box>
                                </Box>

                                <Box onClick={antrepoInVehicleProducts.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={antrepoInVehicleProducts.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className="text-white fa fa-edit" />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                                    </Box>
                                </Box>

                                <Box onClick={antrepoInVehicleProducts.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={antrepoInVehicleProducts.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className="text-white fa fa-trash" />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                                    </Box>
                                </Box>
                            </Box>
                        )
                    }


                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                {
                                                    !isDisabledFromLock && (
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={selectAll} className='form-check-input' type='checkbox' checked={antrepoInVehicleProducts.filter(x => x.isSelected).length > 0 && antrepoInVehicleProducts.filter(x => x.isSelected).length == antrepoInVehicleProducts.length} />
                                                            </label>
                                                        </div>
                                                    )
                                                }
                                            </th>
                                            <th style={{ width: 1 }}>Grup Sıra No</th>
                                            <th>GTip No</th>
                                            <th>Ürün Cinsi</th>
                                            <th>Ürün Özelliği</th>
                                            <th>Ürün Lokasyonu</th>
                                            <th>Kap Cinsi</th>
                                            <th>Palet Adet</th>
                                            <th style={{ width: 1 }}>Kap Adet</th>
                                            <th style={{ width: 1 }}>Brüt Ağırlık (Kg)</th>
                                            <th style={{ width: 1 }}>Net Ağırlık (Kg)</th>
                                            <th style={{ width: 1 }}>Hacim (M3)</th>
                                            <th style={{ width: 1 }}>Alan (M2)</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoInVehicleProducts.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            antrepoInVehicleProducts.sort(function (a, b) {
                                                return Helpers.toNumber(a.groupNo) - Helpers.toNumber(b.groupNo);
                                            }).map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        {
                                                            !isDisabledFromLock && (
                                                                <div className='d-flex'>
                                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                        <input onChange={() => setItemSelected(item.antrepoInVehicleProductId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                    </label>
                                                                </div>
                                                            )
                                                        }
                                                    </td>
                                                    <td>{item.groupNo}</td>
                                                    <td>{item.gTipName}</td>
                                                    <td>{item.productKindName}</td>
                                                    <td>{item.productTypeName}</td>
                                                    <td>{item.productLocationName}</td>
                                                    <td>{item.potTypeName}</td>
                                                    <td className='custom-text-right'>{item.palletCount}</td>
                                                    <td className='custom-text-right'>{item.potQuantity}</td>
                                                    <td className='custom-text-right'>{item.grossWeight}</td>
                                                    <td className='custom-text-right'>{item.netWeight}</td>
                                                    <td className='custom-text-right'>{item.volume}</td>
                                                    <td className='custom-text-right'>{item.area}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                    {
                                        antrepoInVehicleProducts.length > 0 && (
                                            <tfoot className='text-gray-600 fw-bold'>
                                                <tr style={{ fontWeight: 'bold', color: 'red', borderTop: '1px solid rgba(0, 0, 0, 0.40)' }}>
                                                    <td className="custom-text-right" colSpan={7}>Toplam</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.palletCount).map(x => Helpers.toNumber(x.palletCount)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.potQuantity).map(x => Helpers.toNumber(x.potQuantity)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.grossWeight).map(x => Helpers.toNumber(x.grossWeight)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.netWeight).map(x => Helpers.toNumber(x.netWeight)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.volume).map(x => Helpers.toNumber(x.volume)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.area).map(x => Helpers.toNumber(x.area)))}</td>
                                                </tr>
                                            </tfoot>
                                        )
                                    }
                                </table>
                            </div>
                        </div>
                    </div>

                    <h4 className="mb-10 mt-10 text-black">Stok</h4>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>Depoda Kaldığı Gün</th>
                                            <th>GTip No</th>
                                            <th>Ürün Cinsi</th>
                                            <th>Ürün Özelliği</th>
                                            <th>Kap Cinsi</th>
                                            <th style={{ width: 1 }}>Kap Adet</th>
                                            <th style={{ width: 1 }}>Brüt Ağırlık (Kg)</th>
                                            <th style={{ width: 1 }}>Net Ağırlık (Kg)</th>
                                            <th style={{ width: 1 }}>Hacim (M3)</th>
                                            <th style={{ width: 1 }}>Alan (M2)</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0).length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            getStockGroupedList().map((item, index) =>
                                                <tr>
                                                    <td style={{ fontWeight: 'bold', color: 'red', }} className='text-center'>{item.daysInStorage}</td>
                                                    <td>{item.gTipName}</td>
                                                    <td>{item.productKindName}</td>
                                                    <td>{item.productTypeName}</td>
                                                    <td>{item.potTypeName}</td>
                                                    <td className='custom-text-right'>{item.stockPotQuantity}</td>
                                                    <td className='custom-text-right'>{item.stockGrossWeight}</td>
                                                    <td className='custom-text-right'>{item.stockNetWeight}</td>
                                                    <td className='custom-text-right'>{item.stockVolume}</td>
                                                    <td className='custom-text-right'>{item.stockArea}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                    {
                                        antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0).length > 0 && (
                                            <tfoot className='text-gray-600 fw-bold'>
                                                <tr style={{ fontWeight: 'bold', color: 'red', borderTop: '1px solid rgba(0, 0, 0, 0.40)' }}>
                                                    <td className="custom-text-right" colSpan={5}>Toplam</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.stockPotQuantity).map(x => Helpers.toNumber(x.stockPotQuantity)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.stockGrossWeight).map(x => Helpers.toNumber(x.stockGrossWeight)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.stockNetWeight).map(x => Helpers.toNumber(x.stockNetWeight)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.stockVolume).map(x => Helpers.toNumber(x.stockVolume)))}</td>
                                                    <td className="custom-text-right">{Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.stockArea).map(x => Helpers.toNumber(x.stockArea)))}</td>
                                                </tr>
                                            </tfoot>
                                        )
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default ProductInformation;